import en from './billSwitchStrings.en';

export default {
  en,
};
